import type { PropsWithChildren } from 'react';
import { rowStyle } from '~/_shared/baseComponents/table/table.styles';

type TableRowProps = PropsWithChildren<{
  readonly className?: string;
}>;

export const TableRowComponent = ({ children, className }: TableRowProps) => {
  return (
    <div
      css={rowStyle}
      className={`row ${className ?? ''}`}
    >
      {children}
    </div>
  );
};
